import MainTable from "../../components/Leaderboard/MainTable";
import OwnTable from "../../components/Leaderboard/OwnTable";
import Error from "../../components/ui/Error";
import { arrayOfObjectMerge, arraySortAndSerialize, calculateTotalMark, groupByUser, mergeWithAllUsers } from "../../HelperFunctions/leaderboardHelper";
import { usePageTitle } from "../../hooks/usePageTitle";
import LeaderBoardLoader from "../../Loader/student/LeaderBoardLoader";
import { useGetAssignmentMarkQuery } from "../../redux/features/assignment/assignmentApi";
import { useGetUsersQuery } from "../../redux/features/auth/authApi";
import { useGetQuizzesMarkQuery } from "../../redux/features/quiz/quizApi";


export default function Leaderboard() {
  usePageTitle(`Leaderboard`);
  const { data: quizzesMark, isLoading, isError } = useGetQuizzesMarkQuery();
  const { data: assignmentMarks, isLoading: aLoading, isError: aError } = useGetAssignmentMarkQuery();
  const { data: users} = useGetUsersQuery();

  //  decide what to render
  let content = null;
  if (isLoading && aLoading) { content = <LeaderBoardLoader /> }

  else if (!isLoading && !aLoading && (isError || aError)) { content = <Error isPadding={true} /> }

  else if (!isLoading && !aLoading && !isError && !aError && (quizzesMark || assignmentMarks) && users) {

    /// make quiz and assignment group by user 
    const quizGroupByUser = groupByUser(quizzesMark);
    const assignmentGroupByUser = groupByUser(assignmentMarks);


    /// calculate total mark for quiz and assignment by reduce
    const quizMarkListByUser = calculateTotalMark(quizGroupByUser, "totalQuizMark");
    const assignmentMarkListByUser = calculateTotalMark(assignmentGroupByUser, "totalAssignmentMark");

  

    /// merge  quiz and assignment based on user 
    const assignmentAndQuizMerge = arrayOfObjectMerge(quizMarkListByUser, assignmentMarkListByUser);

    // merge participate users with all users
    const mergeMarkWithAllUsers = mergeWithAllUsers(users, assignmentAndQuizMerge)

    /// sort descending and add totalMark and serial property
    const sortAndSerialized = arraySortAndSerialize(mergeMarkWithAllUsers)

    /// filter by serial number (20)
    const filteredLeaderboard = sortAndSerialized.filter(item => item.serial <= Number(process.env.REACT_APP_LEADERBOARD_FILTER_BY))

    content = <div className="mx-auto max-w-7xl px-5 lg:px-0">
      <div>
        <h3 className="text-lg font-bold">Your Position in Leaderboard</h3>
        <OwnTable leaderboard={sortAndSerialized} />
      </div>

      <div className="my-8">
        <h3 className="text-lg font-bold">Top 20 Result</h3>
        <MainTable leaderboard={filteredLeaderboard} />
      </div>
    </div>
  }

  return (
    <section className="py-6 bg-primary">
      {content}
    </section>
  )
};


